import api from './api';

// Ek izin — İK'nın yıllık izin bakiyesine kural dışı eklediği günler. Uçlar
// backend LeaveExtraBalanceController'ın aynasıdır ([Route("v1/leave-extra-balance")],
// her uç LM.Write). Gövde (oluştur/güncelle), LeaveExtraBalanceRequest:
//   { employeeId, leaveVariationId (boş = politikadaki tek yıllık tür), days,
//     effectiveDate ("yyyy-MM-dd", boş = bugün), note (zorunlu) }

// Boş/null parametreleri düşür — sorgu dizesi temiz kalsın.
const clean = (params) => {
  const out = {};
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') out[key] = value;
  });
  return out;
};

// Sayfalı liste: { employeeId, year, pageNumber, pageSize } → PaginatedList.
export const getExtraBalances = (params) =>
  api.get('/v1/leave-extra-balance', { params: clean(params) });

// Çalışanın politikasındaki yıllık türler → { options: [{id,name}], defaultId }.
export const getExtraBalanceVariations = (employeeId) =>
  api.get('/v1/leave-extra-balance/variations', { params: clean({ employeeId }) });

// Başarı toast'ı sunucunun mesajından (leaveExtraBalance.created/updated/deleted)
// interceptor'da çıkar.
export const createExtraBalance = (payload) => api.post('/v1/leave-extra-balance', payload);

export const updateExtraBalance = (id, payload) => api.put(`/v1/leave-extra-balance/${id}`, payload);

export const deleteExtraBalance = (id) => api.delete(`/v1/leave-extra-balance/${id}`);

// Excel — devir ekranıyla (leaveOpeningBalanceService) aynı iki adımlı akış.
export const getExtraBalanceTemplate = () =>
  api.get('/v1/leave-extra-balance/template', { responseType: 'blob' });

export const validateExtraBalanceImport = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/v1/leave-extra-balance/validate', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// DİKKAT: execute, istemciden gelen `rows`'u VERİ olarak alır, karar olarak değil —
// sunucu isValid/employeeId alanlarını yok sayıp doğrulamayı sıfırdan koşar. Sonuç
// execute'un DÖNDÜĞÜ satırlardan okunmalıdır.
export const executeExtraBalanceImport = (rows) =>
  api.post('/v1/leave-extra-balance/execute', { rows });
